import { Select, SelectProps } from 'antd';
import { FormattedMessage } from 'react-intl';

interface ActiveExtraFilter extends SelectProps {
  value?: boolean;
  onChange: (value?: string) => void;
}

function ActiveExtraFilter({ value, onChange, ...props }: ActiveExtraFilter) {
  return (
    <Select
      value={value?.toString()}
      onChange={onChange}
      style={{ width: '100%' }}
      placeholder={<FormattedMessage id="commons.entity.situation" />}
      {...props}
    >
      <Select.Option value="true">
        <FormattedMessage id="commons.entity.active" />
      </Select.Option>
      <Select.Option value="false">
        <FormattedMessage id="commons.entity.inactive" />
      </Select.Option>
    </Select>
  );
}

export default ActiveExtraFilter;
